export default "__VITE_ASSET__02e039ff__"